define([
	"dijit/form/Button",
	"./_Plugin",
	"./PluginFactory"
], function(Button,_Plugin,PluginFactory) {

	return PluginFactory.declare([Button, _Plugin], {
		"class": 'csi-link-btn',
		iconClass: "dijitNoIcon",
		label:  "Cancel",
		pluginName: "cancel",
		title: "Cancel",
		showLabel: true,

		/**
		 * Cancel svg content changes
		 * @param  {Event} e
		 */
		onClick: function(e) {
			const view = this.getView();
			view.splashTemplate.set("disabled", false);
			view.exitEditMode();
		}
	});
});
